// @ts-nocheck

import React from 'react';
import styled, { css } from 'styled-components';

import { FreebetsIcon } from '../../../../assets/img/betting';
import Formatter from '../../../../i18n/formatter';
import { __, getCurrency } from '../../../../i18n/l10n';
import BoomUIBySkinId from '../../constants/ui';
import type { BoomSkinId } from '../../types/global';

const Wrapper = styled.div`
  display: inline-flex;
  position: relative;
`;

const Content = styled.div`
  align-items: center;

  display: flex;
  padding: 0.5em 0.4em;
  position: relative;

  ${({ $skinId }) => {
    const textStyle = BoomUIBySkinId[$skinId]?.TEXT_STYLE ?? {};

    return css`
      color: ${textStyle.color};
    `;
  }}
`;

const Separator = styled.div`
  height: 1.06667em;
  margin: 0 0.5em;
  opacity: 0.5;
  width: 1px;
  border-radius: 1px;

  ${({ $skinId }) => {
    const textStyle = BoomUIBySkinId[$skinId]?.TEXT_STYLE ?? {};

    return css`
      background-color: ${textStyle.separatorColor};
    `;
  }}
`;

const Info = styled.div`
  align-items: baseline;
  display: flex;
  background-color: rgba(255, 255, 255, 0.05);
  padding: 0.6em 0.4em;
  border-radius: 0.6em;
`;

const InfoLabel = styled.div`
  line-height: 1em;
  font-size: 1.1em;
  white-space: nowrap;
  letter-spacing: normal;
  font-weight: normal;

  ${({ $skinId }) => {
    const textStyle = BoomUIBySkinId[$skinId]?.TEXT_STYLE ?? {};

    return css`
      color: ${textStyle.subtitleColor};
    `;
  }}
`;

const InfoValue = styled.div`
  line-height: 0.625em;
  font-size: 1.4em;
  font-weight: bold;
  margin-left: 0.2em;
`;

const InfoIcon = styled.img`
  line-height: 1em;
  height: 1.2em;
  margin-left: 0.3em;
  width: auto;
  transform: translateY(0.1em);
`;

const InfoWinningWrapper = styled.div`
  white-space: nowrap;

  display: inline-flex;
  align-items: center;

  ${({ $skinId }) => {
    const textStyle = BoomUIBySkinId[$skinId]?.TEXT_STYLE ?? {};

    return css`
      color: ${textStyle.wonColor};
    `;
  }}
`;

type PropsType = {
  className?: string;
  skinId: BoomSkinId;
  minBetOdds?: number;
  stakeMultiplier?: number;
  wonAmount?: number;
  isCompleted?: boolean;
};

const BoomStepDetails = ({
  className = '',
  skinId,
  minBetOdds = 0,
  stakeMultiplier = 0,
  wonAmount = 0,
  isCompleted = false,
}: PropsType) => {
  return (
    <Wrapper className={className} $isCompleted={isCompleted}>
      <Content $isCompleted={isCompleted} $skinId={skinId}>
        {isCompleted ? (
          wonAmount !== 0 ? (
            <>
              <InfoWinningWrapper $skinId={skinId}>
                <InfoLabel $skinId={skinId}>{__('Winnings')}</InfoLabel>
                <InfoValue>{Formatter.formatNumber(wonAmount, getCurrency())}</InfoValue>
              </InfoWinningWrapper>
              <InfoIcon src={FreebetsIcon} />
            </>
          ) : null
        ) : (
          <Info>
            <InfoLabel $skinId={skinId}>{__('Min. odds')}</InfoLabel>
            <InfoValue>{Formatter.formatOdd(minBetOdds)}</InfoValue>

            {stakeMultiplier ? (
              <>
                <Separator $skinId={skinId} />

                <InfoLabel $skinId={skinId}>{__('Wager')}</InfoLabel>
                <InfoValue>x{stakeMultiplier}</InfoValue>

                <InfoIcon src={FreebetsIcon} />
              </>
            ) : null}
          </Info>
        )}
      </Content>
    </Wrapper>
  );
};

export default BoomStepDetails;
